import React from "react";
import Axios from "axios";

//context api:  
//https://medium.com/datadriveninvestor/getting-started-w-reacts-context-api-f60aa9be758f

const storeContext = React.createContext();
export const Consumer = storeContext.Consumer;

export class Provider extends React.Component {
	constructor(props) {
		super(props); 
		let restType 			= this.getRestType(props.router.match.path);
		let route 				= props.router.match.path;
		let slug 				= props.router.match.params.slug ? props.router.match.params.slug : '';
		let timer 				= null;
		this.state = {
			newPage: 			true,
			prevSlug: 			'/',
			slug: 				slug,
			restType: 			restType,
			lastRestType: 		null,
			route: 				route,
			posts: 				[], 
			siteLoaded: 		false,
			pageLoaded: 		false,
			pageTitle: 			'',
			currentPage: 		1, 
			totalPages: 		0,      
			appError : 			'',
			frmMsg: 			'',
			global: {
				json: 			null,
				globalFetched: 	false,
			},
			getGlobal: 			this.getGlobal.bind(this),
		};
	}
		
	getRestType (path){
		let restType = '';
		switch(path){   
			case '/':
				restType = 'front';
				break; 
			default:
				restType = 'page';
			break;
		}
		return restType;
	}

	componentDidMount(){ 
    	this.getPosts(this.buildUrl());   
	}

	componentDidUpdate(prevProps){ 
		if(prevProps.router.location.pathname.split('#')[0] !== this.props.router.location.pathname.split('#')[0]){  
			let prev = prevProps.router.location.pathname.split('#')[0];
			let current = this.props.router.location.pathname.split('#')[0];
			if (prev !== current) {
				this.setState({newPage: true});
			} else {
				this.setState({newPage: false});
			}
			
			let curProps 	= this.props.router.match; 
			let prevSlug 	= prevProps.router.match.params.slug ? prevProps.router.match.params.slug : '';
			
			this.setState({
				currentPage: 	1, 
				lastRestType: 	this.state.restType,
				restType: 		this.getRestType(curProps.path), 
				slug: 			this.props.router.match.params.slug ? this.props.router.match.params.slug : '',
				prevSlug: 		prevProps.router.match.params.slug ? prevProps.router.match.params.slug : '',
			},function(){
				this.getPosts(this.buildUrl()); 
			})
		} else {
			if (this.props.router.location.hash.split('#')[1] === 'info') {
				window.scroll({
					behavior: 'smooth',
					left: 0,
					top: window.innerHeight
  				});
			}
		}
	}
	
	getGlobal(url) {
		let self = this;
		let global = this.state.global;
		if (global.json === null && global.globalFetched === false) {
			global.globalFetched = true;
			self.setState({
				global : global
			});
			Axios.get(url).then((response)=>{
				global.json = response.data[0];
				global.globalFetched = true;
				self.setState({
					global : global
				});
			}); 
		}
	}

	buildUrl(){
		let url = '/wp-json/the-bend/v1/';  
		switch(this.state.restType){   
			case 'front': 
				url += 'front';
				break;  
			case 'page': 
				default: 
				url += 'page/';
				url += this.state.slug
				break;        
		}
		return url;
	}

	getPosts (url){
		
		let self = this;
		let slug = this.state.slug;
		let lastRestType = this.state.lastRestType;
		
		document.documentElement.classList.remove('state-page-loaded');
		
		setTimeout(() => {		
				
		    Axios.get(url).then((response)=>{
				self.setState({
					posts : response.data, 
					totalPages : response.headers['x-wp-totalpages']
				},function(){   
					
					document.title = response.data[0].page_title;
					
					self.setState({
						pageTitle: response.data[0].title
					});
					
					document.documentElement.classList.add('state-page-loaded');
					window.scrollTo(0,0);
					
				});
			}).catch(function(error){
				self.appError = 'An unexpected error occurred';
			}); 
			
		}, 400);
	}

	render() {
    	return (
			<storeContext.Provider value={this.state}>
				{this.props.children}
			</storeContext.Provider>
		);
	}
}